export class InvoicePdf {
  centeraId: string;
  content: string;
  credential: string;
  language: string;
  link: string;
  name: string;
  ref: string;
  s3Uuid: string;
  size: string;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
